import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { Button, Modal } from "components/AtomsV2";
import { Icon } from "components/ShellV2";

/* Acknowledgments modal shown from the login screen. Content lives in i18n
   (auth ns, `acknowledgments.*`); `acknowledgments.projects` is an array of
   { name, prog, ref, body, fund }. */
function AcknowledgmentsModal({ open, onClose }) {
  const { t } = useTranslation(["auth"]);
  const projects = t("acknowledgments.projects", { returnObjects: true });
  const list = Array.isArray(projects) ? projects : [];

  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth={720}
      footer={
        <Button onClick={onClose}>
          <Icon name="check" />
          {t("acknowledgments.close")}
        </Button>
      }
    >
      <div className="flex items-start gap-3 mb-3">
        <span
          className="inline-flex items-center justify-center w-9 h-9 rounded-[10px] shrink-0"
          style={{
            background: "var(--accent-soft, rgba(16,181,160,.12))",
            color: "var(--accent-deep)",
          }}
        >
          <Icon name="volunteer_activism" fill />
        </span>
        <div className="min-w-0">
          <div className="text-[11px] font-semibold uppercase tracking-[0.06em] text-ink-3">
            {t("acknowledgments.modal_kicker")}
          </div>
          <h3 className="text-[18px] font-bold text-ink m-0">{t("acknowledgments.modal_title")}</h3>
        </div>
      </div>

      <div className="max-h-[58vh] overflow-y-auto pr-1">
        <p className="text-[13px] text-ink-2 leading-[1.6] mb-4">{t("acknowledgments.intro")}</p>
        <div className="flex flex-col gap-3">
          {list.map((p) => (
            <section
              key={p.name}
              className="rounded-[12px] p-4"
              style={{
                background: "var(--surface-2)",
                border: "1px solid var(--border)",
              }}
            >
              <div className="mb-1.5">
                <div className="text-[11px] font-semibold uppercase tracking-[0.06em] text-ink-3">
                  {p.prog}
                </div>
                <h4 className="text-[15px] font-bold text-ink m-0">{p.name}</h4>
              </div>
              <p className="text-[13px] text-ink-2 leading-[1.6] mb-2">{p.body}</p>
              <p className="text-[12px] text-ink-3 leading-[1.55] mb-2">{p.fund}</p>
              <div className="inline-flex items-center gap-1 text-[12px] font-medium text-ink-3">
                <Icon name="tag" style={{ fontSize: 13 }} />
                {p.ref}
              </div>
            </section>
          ))}
        </div>
      </div>
    </Modal>
  );
}

AcknowledgmentsModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

AcknowledgmentsModal.defaultProps = {
  open: false,
  onClose: undefined,
};

export default AcknowledgmentsModal;
